<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'DateAlertBanner',
  mixins: [baseMixin],
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
  },
}
</script>

<template>
  <v-alert
    height="69"
    class="date-alert-banner"
    icon="mdi-alert-circle-outline"
    text
    type="info"
  >
    <div class="alert-title">{{ title }}</div>
    <div class="alert-description">{{ description }}</div>
  </v-alert>
</template>

<style lang="scss" scoped>
.v-alert--text::before {
  background-color: unset !important;
}
</style>
